export default __webpack_public_path__ + "static/media/video-mobile.06f289b5.mp4";